import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg)
  }
`;

const bounce = keyframes`
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
`;

export const SpinnerBlock = styled.div`
  background-color: rgba(0, 0, 0, 0.4);
  display: block;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 13;
`;

export const SpinnerOverlay = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const InnerSpinner =  styled.div`
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;

  -webkit-animation: ${rotate} 2.0s infinite linear;
  animation: ${rotate} 2.0s infinite linear;
`;

export const Dot = styled.div`
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #fff;
  border-radius: 100%;

  -webkit-animation: ${bounce} 2.0s infinite ease-in-out;
  animation: ${bounce} 2.0s infinite ease-in-out;

  &.dot2 {
    top: auto;
    bottom: 0;
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }
`;

export const LoadingText = styled.div`
  color: #fff;
  font-size: 1.5rem;
  margin-top: -80px;
`;



// WEBPACK FOOTER //
// ./src/components/Spinner/styledComponents.js